<template>
	<div>
	<van-sticky>
		<div class="rcst_sc">
			<div @click="backPrev()" class="rcst_sc_drop">
				<div class="rcst_sc_drop_left">
					<img src="../demo1/source/back.png" alt="" />
				</div>
			</div>
			<div class="rcst_sc_drop_center">登录</div>
		</div>
	</van-sticky>
	<div class="login">
		
		<div class="login_block">
			<div class="login_block_title">登录</div>
			<div class="login_block_item login_block_item_1">
				<input v-model="phone" type="tel" maxlength="11" placeholder="请输入手机号" />
			</div>
			<div class="login_block_item login_block_item_3">
				<Captcha ref="captchaRef" @validated="handleValidation" />
			</div>
			
			<div class="login_block_item login_block_item_2">
				<input v-model="sms" type="tel" maxlength="4" placeholder="请输入验证码" />
				<div @click="getSmsCodeBefore()" class="login_block_item_sms">{{reg_cd_time==60?reg_cd_msg:reg_cd_time+'s'}}
				</div>
			</div>
			<div @click="agreeProtol()" class="login_block_protol">
				<div :class="[{'login_block_protol_agree':is_agree},'login_block_protol_noagree']"></div>
				我已阅读并同意<span @click.stop="protol_show=true">《隐私协议》</span>
			</div>
			<div @click="login()" class="login_block_btn">登录</div>
		</div>

		<van-popup v-model="protol_show" style="width:calc(100vw - 70px);border-radius: 8px;">
			<div class="login_pop">
				<div class="login_pop_title">《隐私协议》</div>
				<div class="login_pop_content">
					尊敬的用户您好：本服务由第三方公司-上海费登奎斯健康科技有限公司提供，为保证您的权益使用安全顺畅，在登录和提交订单等使用环节需输入并不仅限于使用人员姓名、手机号，本服务承诺尊重并保护所有使用服务用户的个人隐私权，在未征得您事先许可的情况下，不会将这些信息对外披露或向第三方提供。感谢您的理解和支持！
				</div>
				<div @click="protol_show=false" class="login_pop_btn">已阅读</div>
			</div>
		</van-popup>

	</div>
	</div>
</template>

<script>
	import Captcha from '../../components/Captcha.vue';
	import {
		futureTimesGroup,
		isPhone,
	} from "../../lib/utils.js"
	export default {
		components: {
			Captcha
		},
		data() {
			return {
				is_agree: false,
				protol_show: false,

				phone: '',
				sms: '',

				reg_cd_time: 60,
				reg_cd_msg: '获取验证码',
				is_captcha:false
			}
		},
		mounted() {
			console.log(window.localStorage);
			document.title='登录'
		},
		methods: {
			backPrev(){
				this.$router.go(-1)
			},
			handleValidation(isValid) {
				// console.log(isValid);
				if (isValid) {
					// 验证通过后的业务逻辑
					this.getSmsCode()
				}
			},
			getSmsCodeBefore(){
				if (!isPhone(this.phone)) {
					this.$toast('请输入手机号');
					return
				}
				this.$refs.captchaRef.validate();
			},
			getSmsCode() {
				// if(!this.is_captcha){
				// 	this.$toast('请输入正确验证码');
				// 	return
				// }
				var $this = this
				if (this.reg_cd_time < 60) {
					return
				}
				if (!isPhone(this.phone)) {
					$this.$toast('请输入手机号');
					return
				}
				this.$loading('正在发送验证码...');
				var $this = this
				var param = {
					mobile: this.phone
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_sendMobileCode
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						$this.$loading.close();
						$this.cutDownTime()
					}).catch((error) => {
						$this.$loading.close();
						console.warn(error, 'err')
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})
			},
			cutDownTime() {
				let inter = setInterval(function() {
					this.reg_cd_time = this.reg_cd_time - 1
					if (this.reg_cd_time < 1) {
						clearInterval(inter)
						this.reg_cd_msg = '重新获取'
						this.reg_cd_time = 60
					}
				}.bind(this), 1000);
			},
			agreeProtol() {
				this.is_agree = !this.is_agree
			},
			login() {
				
				/*
					localStorage.setItem('dparams',JSON.stringify(params))
					this.$router.push({
						name: 'venue_goods_createorder',
						params: {
							goodsId: this.good_detail.goodsId,
							date:this.dateList[this.date_index].date,
							time:e
						}
					})
				*/
				
				/*
					localStorage.setItem('dparams2',JSON.stringify(params))
					this.$router.push({
						name:'venue_goods_createorder2',
						params: {
							course_timetable_id:this.select_course_time.course_timetable_id,
							date: date,
							time:this.select_course_time.time_txt,
							venue_name:this.select_course.venue_name,
							course_name:this.select_course.course_name
						}
					})
				*/ 
				
				// return
				
				var $this = this
				if (!this.is_agree) {
					this.$toast('请阅读并同意《隐私协议》');
					return
				}
				this.$loading('正在登录中...');
				var param = {
					mobile: this.phone,
					code: this.sms
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_login
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res);
						
						
						
						try {
						    // 检查是否支持localStorage
							if (!window.localStorage){
								$this.$loading.close();
								$this.$toast('请更换浏览器使用');
								return
							}
						    
						    // 尝试写入
						    localStorage.setItem('token', res.data.token)
						    $this.$loading.close();
						    $this.$toast('登陆成功');
						    setTimeout(()=>{
						    	// $this.$router.go(-1)
								$this.$router.push({
									name:'venue_goods'
								})
						    },500)
						    return true;
						  } catch (e) {
							  $this.$loading.close();
						    // 处理错误情况
						    console.error('Failed to set localStorage item:', e);
						    
						    // 检查是否因隐私模式或存储满导致
						    if (e.name === 'QuotaExceededError') {
						      // 可以尝试清理旧数据或提示用户
						      
						      $this.$toast('请更换浏览器使用');
						      return false;
						    }
						    
						    return false;
						  }
						  
					}).catch((error) => {
						$this.$loading.close();
						console.warn(error, 'err')
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})

				/*
				user/login
				mobile   code
				*/
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.rcst_sc {
		width: 100%;
		/* padding: 0 30*@vm_base; */
		padding: 0 30*@vm_base;
		// padding: 0 0 20*@vm_base 0;
		background-color: #fff;
		
		display: flex;
		justify-content: space-between;
		align-items: center;
	
		.rcst_sc_drop {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: fit-content;
			
			.rcst_sc_drop_left{
				width: 80*@vm_base;
				height: 80*@vm_base;
				// border: 1*@vm_base solid red;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				img{
					width: 36*@vm_base;
				}
			}
		}
		.rcst_sc_drop_center{
			width: calc(100% - 80*@vm_base);
			height: 80*@vm_base;
			padding-right: 80*@vm_base;
			font-size: 28*@vm_base;
			color: #666666;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.login {
		width: 100%;
		min-height: 100vh;
		padding: 60*@vm_base;
	}

	.login_block {
		width: 100%;
		border-radius: 16*@vm_base;
		padding: 40*@vm_base 30*@vm_base;
		background-color: #fff;
	}

	.login_block_title {
		width: 100%;
		text-align: center;
		font-weight: bold;
		font-size: 38*@vm_base;
		color: #333;
	}

	.login_block_item {
		width: 100%;
		border: 1*@vm_base solid #d9d9d9;
		border-radius: 8*@vm_base;
		margin-top: 40*@vm_base;
		padding: 0 0 0 80*@vm_base;
		position: relative;
		background-size: 40*@vm_base;
		background-repeat: no-repeat;
		background-position: 20*@vm_base center;

		input {
			width: 100%;
			height: 90*@vm_base;
			border: none;
			outline: none;
			font-size: 28*@vm_base;
			border-radius: 8*@vm_base;
		}

		.login_block_item_sms {
			position: absolute;
			top: 0;
			right: 0;
			width: fit-content;
			min-width: 200*@vm_base;
			height: 100%;
			padding: 0 10*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 28*@vm_base;
			color: #FB8027;
		}
	}
	.login_block_item_1 {
		background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20231013_oc6CEJvy78Acv8m.png);
	}
	.login_block_item_2 {
		background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20231013_bwGW9OnguPQhNQP.png);
	}
	.login_block_item_3{
		background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20250419_EsHL7JghuVbC1ox.png);
		background-size: 36*@vm_base;
	}

	.login_block_protol {
		width: fit-content;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 28*@vm_base;
		color: #666;
		margin-top: 30*@vm_base;

		.login_block_protol_noagree {
			width: 32*@vm_base;
			height: 32*@vm_base;
			border-radius: 50%;
			border: 1*@vm_base solid #d9d9d9;
			margin-right: 10*@vm_base;
		}

		span {
			color: #FB8027;
		}

		.login_block_protol_agree {
			border: 1*@vm_base solid #FB8027;
			background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240624_kVfnXoyabQEkVQG.png);
			background-size: 100%;
			background-position: center;
			background-repeat: no-repeat;
		}
	}

	.login_block_btn {
		width: 280*@vm_base;
		height: 80*@vm_base;
		margin: 0 auto;
		margin-top: 30*@vm_base;
		background-color: #FB8027;
		border-radius: 40*@vm_base;
		color: #fff;
		font-size: 28*@vm_base;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.login_pop {
		width: 100%;
		padding: 40*@vm_base 30*@vm_base;

		.login_pop_title {
			width: 100%;
			text-align: center;
			font-size: 38*@vm_base;
			color: #333;
			font-weight: bold;
		}

		.login_pop_content {
			font-size: 28*@vm_base;
			line-height: 1.5;
			color: #666;
			text-indent: 2em;
			margin-top: 30*@vm_base;
		}

		.login_pop_btn {
			width: 300*@vm_base;
			height: 80*@vm_base;
			background-color: #FB8027;
			border-radius: 40*@vm_base;
			margin: 0 auto;
			margin-top: 30*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #fff;
			font-size: 28*@vm_base;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/demo1/login.vue